import type { RootState } from '@/shared/store/store';

export const selectClaimDetail = (state: RootState) => state.claims.detail;
export const selectClaimById = (id: string) => (state: RootState) =>
  state.claims.entities[id] ?? null;
export const selectClaimMutation = (state: RootState) => state.claims.mutation;
